<template>
    <svg :width="width" :height="height" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.8296 11.3874C24.4378 10.7948 24.6524 9.92513 24.3899 9.11813C24.1279 8.31081 23.4431 7.73345 22.6027 7.61134L17.4143 6.85745C17.1509 6.81901 16.9233 6.65368 16.8056 6.41518L14.4852 1.71324C14.1095 0.952227 13.3488 0.479492 12.5 0.479492C11.6511 0.479492 10.8905 0.952227 10.5147 1.71324C10.5147 1.71329 8.19435 6.41513 8.19435 6.41513C8.0766 6.65373 7.84902 6.81906 7.58605 6.8574L2.39727 7.61129C1.5569 7.73345 0.8721 8.31081 0.61021 9.11771C0.347569 9.92513 0.56221 10.7949 1.17023 11.3872L4.92482 15.0474C5.11527 15.233 5.20218 15.5003 5.15732 15.7622L4.27082 20.9304C4.12757 21.7671 4.46502 22.5967 5.15151 23.0953C5.83813 23.5942 6.73157 23.6589 7.48326 23.264L12.124 20.8241C12.3594 20.7004 12.6405 20.7004 12.8757 20.8239L17.5168 23.264C18.2684 23.6589 19.1619 23.5942 19.8485 23.0953C20.5349 22.5966 20.8724 21.7671 20.7292 20.9304L19.8426 15.7624C19.7978 15.5003 19.8846 15.233 20.0752 15.0473L23.8296 11.3874ZM18.4566 15.9998L19.3432 21.1681C19.3962 21.4777 19.2762 21.773 19.022 21.9576C18.8809 22.0601 18.7175 22.1143 18.5492 22.1143C18.4755 22.1143 18.3342 22.1049 18.1708 22.0191L13.5301 19.5792C13.2133 19.4129 12.8573 19.3251 12.5001 19.3251C12.1426 19.3251 11.7864 19.413 11.47 19.5792L6.82883 22.0194C6.51004 22.1868 6.19101 22.1124 5.97815 21.9577C5.7239 21.773 5.60385 21.4777 5.65691 21.1677L6.54337 16C6.66637 15.2812 6.42815 14.5488 5.90629 14.0403L2.15188 10.3803C1.9266 10.1608 1.85029 9.85154 1.94751 9.55276C2.04468 9.25342 2.28833 9.0482 2.59958 9.00296L7.78818 8.24907C8.50996 8.14379 9.13288 7.69098 9.45538 7.03759L11.7757 2.33584C11.9148 2.05402 12.1856 1.88579 12.5 1.88579C12.8144 1.88579 13.0852 2.05402 13.2243 2.33584L15.5446 7.03754C15.8672 7.69102 16.4902 8.14384 17.2113 8.24902C18.3616 8.41604 20.5647 8.73591 22.4003 9.00296C22.7117 9.0482 22.9554 9.25356 23.0524 9.55229C23.1498 9.85168 23.0734 10.1608 22.8483 10.3801L19.0936 14.0403C18.5718 14.5488 18.3336 15.2814 18.4566 15.9998Z" :fill="color" :fill-opacity="opacity"/>
    </svg>
</template>

<script>
export default {
	name: "PopularIcon",
	props: {
		height: {
			type: Number,
			default: 24
		},
		width: {
			type: Number,
			default: 24
		},
        color: {
            type: String,
            default: 'white'
        },
        opacity: {
            type: String,
            default: ''
        }
  	}
}
</script>
